import type {Recipe} from './types';

export const spaghettiConBurrataECompostaDiCipolle: Recipe = {
    id: 16,
    key: "spaghettiConBurrataECompostaDiCipolle",
    pictures: [
        {index: 0, url: "https://blog.giallozafferano.it/ombraincucina/wp-content/uploads/2015/05/IMG_6624.jpg"},
    ],
    i18n: {
        IT: {
            title: "Spaghetti con Burrata e Composta di Cipolle",
            servings: "2 persone",
            ingredients: [
                "Spaghetti",
                "1 spicchio d'aglio",
                "Olio extra vergine di oliva",
                "Passata di pomodoro",
                "Sale",
                "1 burrata",
                "Composta di cipolle",
            ],
            steps: [
                "Schiacciare con il dito o con un coltello un pezzo d'aglio senza pelarlo e senza tagliarlo.",
                "Mettere l'aglio a cuocere a fuoco basso nell'olio extra vergine di oliva.",
                "Rimuovere l'aglio quando è dorato chiaro e tutti i pezzi sono rimasti nell'olio.",
                "Aspettare un minuto affinché l'olio si raffreddi leggermente e poi aggiungere la passata di pomodoro.",
                "Cuocere la passata nell'olio (senza coprire) e aggiungere un po' di sale mentre bolle.",
                "Cuocere gli spaghetti e conservare un bicchiere di acqua di cottura.",
                "Fermare l'ebollizione della salsa quando non è più possibile riconoscere l'olio dalla passata (l'olio si separa dalla passata) e non è troppo liquida.",
                "Mettere la pasta ancora \"al dente\" nella salsa e cuocere per un minuto o più (provare la pasta per vedere quando è pronta).",
                "Versare una quantità molto piccola di acqua di cottura nella padella e continuare a mescolare la pasta con la salsa (fare attenzione a non rendere la salsa troppo liquida).",
                "Mettere la pasta e la salsa su un piatto.",
                "Aprire una burrata e schiacciarla con una forchetta (diventerà \"stracciatella\").",
                "Mettere pezzi di burrata e un po' di composta di cipolle sulla pasta.",
            ],
        },
        EN: {
            title: "Spaghetti with Burrata and Onion Compote",
            servings: "2 servings",
            ingredients: [
                "Spaghetti",
                "1 garlic clove",
                "Extra virgin olive oil",
                "Tomato puree",
                "Salt",
                "1 burrata",
                "Onion compote",
            ],
            steps: [
                "Crush a garlic clove with your finger or a knife without peeling or cutting it.",
                "Cook the garlic over low heat in extra virgin olive oil.",
                "Remove the garlic when it is light golden and all the pieces have remained in the oil.",
                "Wait a minute for the oil to cool slightly, then add the tomato puree.",
                "Cook the puree in the oil (uncovered) and add a bit of salt while it boils.",
                "Cook the spaghetti and save a glass of cooking water.",
                "Stop boiling the sauce when it is no longer possible to distinguish the oil from the puree (the oil separates from the puree) and it is not too liquid.",
                "Put the pasta, still \"al dente,\" into the sauce and cook for a minute or more (taste the pasta to see when it is ready).",
                "Pour a very small amount of cooking water into the pan and continue stirring the pasta with the sauce (be careful not to make the sauce too liquid).",
                "Place the pasta and sauce on a plate.",
                "Open a burrata and mash it with a fork (it will become \"stracciatella\").",
                "Place pieces of burrata and a bit of onion compote on the pasta.",
            ],
        },
        PL: {
            title: "Spaghetti z Burratą i Konfiturą z Cebuli",
            servings: "2 porcje",
            ingredients: [
                "Spaghetti",
                "1 ząbek czosnku",
                "Oliwa z oliwek extra vergine",
                "Przecier pomidorowy",
                "Sól",
                "1 burrata",
                "Konfitura z cebuli",
            ],
            steps: [
                "Zgnieć ząbek czosnku palcem lub nożem bez obierania i krojenia.",
                "Smaż czosnek na małym ogniu w oliwie z oliwek extra vergine.",
                "Usuń czosnek, gdy będzie lekko złoty, a wszystkie kawałki pozostaną w oleju.",
                "Odczekaj minutę, aby olej lekko ostygł, a następnie dodaj przecier pomidorowy.",
                "Gotuj przecier w oleju (bez przykrycia) i dodaj trochę soli, gdy zacznie wrzeć.",
                "Ugotuj spaghetti i zachowaj szklankę wody z gotowania.",
                "Zatrzymaj gotowanie sosu, gdy nie będzie już można odróżnić oleju od przecieru (olej oddziela się od przecieru) i nie będzie zbyt płynny.",
                "Włóż makaron, nadal \"al dente\", do sosu i gotuj przez minutę lub dłużej (spróbuj makaronu, aby sprawdzić, kiedy jest gotowy).",
                "Wlej bardzo małą ilość wody z gotowania do patelni i kontynuuj mieszanie makaronu z sosem (uważaj, aby sos nie był zbyt płynny).",
                "Nałóż makaron i sos na talerz.",
                "Otwórz burratę i rozgnieć ją widelcem (zamieni się w \"stracciatella\").",
                "Nałóż kawałki burraty i trochę konfitury z cebuli na makaron.",
            ],
        },
    },
};
